// extracted by mini-css-extract-plugin
export default {"MobileGallery":"styles_MobileGallery__aI76y","container":"styles_container__LhzTe","button":"styles_button__37S+k","images":"styles_images__riY+8"};